<template>
  <div>
    <RouterView :key="routerViewKey" />
  </div>

  <div class="modal-target" />
</template>

<script lang="ts" setup>
  import '@/app/styles/main.scss';
  import { captureException, reportMFRendered } from '@experience/core-hostapp-share-lib';
  import { initHotReloader, setCssFilesLinksAttribute } from '@experience/vite-plugin-wc-extract-styles';
  import { computed, onErrorCaptured, onMounted, useShadowRoot, provide, nextTick } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  import { useExperienceClient } from '@/shared/api/useExperienceApiClient';

  import { MF_NAME, SENTRY_DSN } from './const';

  onErrorCaptured((err) => captureException(err, { mf: MF_NAME, dsn: SENTRY_DSN, mfRelease: __APP_VERSION__ }));

  const route = useRoute();
  const router = useRouter();

  /** fullPath без #hash — смена якоря не пересоздаёт страницу */
  const routerViewKey = computed(() => route.fullPath.replace(/#.*$/, ''));

  useExperienceClient();
  onMounted(async () => {
    await router.isReady();
    await nextTick();

    setTimeout(() => {
      reportMFRendered(MF_NAME);
    }, 0);
  });

  const shadowRoot = useShadowRoot();

  provide('shadowRoot', shadowRoot);

  initHotReloader(import.meta.hot, shadowRoot);
  setCssFilesLinksAttribute(
    shadowRoot,
    import.meta.env.MODE === 'production' ? `/mfs/${MF_NAME}/` : '/',
    'data-external-style-url',
    '%%PROD_STYLESHEET_FILE_LINK%%',
    '',
  );
</script>
